__turbopack_context__.v({
  "clientInactiveCompanyOverlay": "ClientInactiveCompanyOverlay-module__kaZkSq__clientInactiveCompanyOverlay",
});
